import { getPermissionsApi,getRolesApi,updatePermissionsApi } from "api/services/roles";
import { Button } from "components/Button";
import { useEffect,useState } from "react";
import { Link } from "react-router-dom";
import { Bounce,toast } from 'react-toastify';
import Breadcrumbs from "../../../../components/Breadcrumbs";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
import RolesPermissionsModal from "../../../../components/modelpopup/RolesPermissionsModal";

const RolesPermissions = () => {
 
  // const roles = [
  //   "Administrator",
  //   "CEO",
  //   "Manager",
  //   "Team Leader",
  //   "Accountant",
  //   "Web Developer",
  //   "Web Designer",
  //   "HR",
  //   "UI/UX Developer",
  //   "SEO Analyst",
  // ];



  const [roles, setRoles] = useState([])
  const [permissions, setPermissions] = useState([])

  const [selectedRole, setSelectedRole] = useState(null)
  const [loading, setLoading] = useState(false)
  const [rolesLoading, setRolesLoading] = useState(true)

  useEffect(()=>{
    
    getPermissionsApi().then(response=>{
     
      setPermissions(response.data)
    })
    fetchRole()
  },[])

  const fetchRole = () => {
    setRolesLoading(true)
    getRolesApi().then(response=>{
      let all_roles = response?.data?.results?.map(item=> {
        return {
          ...item,
          permissions: item?.permissions?.map(p_item=> {
            return {...p_item,enabled: true}
          }) || []
        }
      })
      setRoles(all_roles || [])
      setRolesLoading(false)
    }).catch(e => {
      setRolesLoading(false)
    })
  }

  const  changePermission = (e, index) => {
    let selected = {...selectedRole}
    selected.permissions[index].enabled = e.target.checked
    setSelectedRole(selected)
  }
  const setRole = (role) => {
    
    let _selected = {...role}
    const map = new Map();

  [...permissions, ..._selected?.permissions].forEach(item => {
    map.set(item.id, item); // Keeps only the latest entry by id
  });
  _selected.permissions = Array.from(map.values())


    setSelectedRole(_selected)
  }

  const updatePermissions = () => {
    setLoading(true)
    let _selected = {access_scope: selectedRole?.access_scope, is_manager: selectedRole?.is_manager}
    
    
    let selected_permissions = selectedRole.permissions?.filter(item=> item.enabled).map(item=> item.id)
    _selected.permissions = selected_permissions
    updatePermissionsApi(selectedRole?.id, _selected).then(response=>{
      fetchRole()
      setLoading(false)
      toast.success('Permissions updated!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });

    }).catch(e=>{
      setLoading(false)
      toast.error('Error updating Permissions !', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
    })
  }
  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs maintitle="Roles & Permissions" />

          <div className="row g-3">
            {/* Roles Sidebar */}
            <div className="col-sm-4 col-md-4 col-lg-4 col-xl-3">
              <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                <div className="card-body p-3">
                  <h5 style={{ 
                    fontSize: "16px", 
                    fontWeight: "600", 
                    color: "#333", 
                    marginBottom: "16px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px"
                  }}>
                    <i className="fa fa-users" style={{ fontSize: "16px", color: "#667eea" }}></i>
                    Roles
                  </h5>
                  {rolesLoading ? (
                    <div style={{ textAlign: "center", padding: "20px" }}>
                      <i className="fa fa-spinner fa-spin" style={{ fontSize: "20px", color: "#667eea" }}></i>
                      <p style={{ marginTop: "8px", color: "#8b949e", fontSize: "12px" }}>Loading roles...</p>
                    </div>
                  ) : roles && roles.length > 0 ? (
                    <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                      {roles.map((role, index) => (
                        <li 
                          key={role?.id || index} 
                          style={{
                            marginBottom: "8px"
                          }}
                        >
                          <Link 
                            to="#" 
                            onClick={(e) => {
                              e.preventDefault();
                              setRole(role);
                            }}
                            style={{
                              display: "block",
                              padding: "12px 16px",
                              borderRadius: "8px",
                              textDecoration: "none",
                              color: selectedRole?.id === role?.id ? "#667eea" : "#333",
                              backgroundColor: selectedRole?.id === role?.id ? "rgba(102, 126, 234, 0.1)" : "transparent",
                              fontWeight: selectedRole?.id === role?.id ? "600" : "400",
                              border: selectedRole?.id === role?.id ? "1px solid #667eea" : "1px solid transparent",
                              transition: "all 0.2s ease",
                              cursor: "pointer"
                            }}
                            onMouseEnter={(e) => {
                              if (selectedRole?.id !== role?.id) {
                                e.currentTarget.style.backgroundColor = "#f8f9fa";
                                e.currentTarget.style.borderColor = "#e0e0e0";
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (selectedRole?.id !== role?.id) {
                                e.currentTarget.style.backgroundColor = "transparent";
                                e.currentTarget.style.borderColor = "transparent";
                              }
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                              <i 
                                className={`fa ${selectedRole?.id === role?.id ? "fa-shield" : "fa-user-shield"}`}
                                style={{ 
                                  fontSize: "14px",
                                  color: selectedRole?.id === role?.id ? "#667eea" : "#8b949e"
                                }}
                              ></i>
                              <span>{role?.name || "Unnamed Role"}</span>
                            </div>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <div style={{
                      textAlign: "center",
                      padding: "20px",
                      background: "#f8f9fa",
                      borderRadius: "8px",
                      border: "1px dashed #dee2e6"
                    }}>
                      <i className="fa fa-users-slash" style={{ fontSize: "24px", color: "#adb5bd", marginBottom: "8px" }}></i>
                      <p style={{ color: "#8b949e", fontSize: "12px", marginBottom: 0 }}>No roles found</p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Permissions Panel */}
            <div className="col-sm-8 col-md-8 col-lg-8 col-xl-9">
              {selectedRole ? (
                <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                  <div className="card-body p-4">
                    {/* Header */}
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <div>
                        <h5 style={{ 
                          fontSize: "18px", 
                          fontWeight: "600", 
                          color: "#333", 
                          marginBottom: "4px",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px"
                        }}>
                          <i className="fa fa-key" style={{ fontSize: "16px", color: "#667eea" }}></i>
                          Module Access
                        </h5>
                        <p style={{ 
                          fontSize: "13px", 
                          color: "#8b949e", 
                          marginBottom: 0 
                        }}>
                          {selectedRole?.name} - Configure permissions
                        </p>
                      </div>
                      {selectedRole && (
                        <Button
                          label="Update Permissions"
                          disabled={loading || !selectedRole?.can_update_permissions}
                          loading={loading}
                          className="btn btn-primary"
                          style={{ borderRadius: "8px", minWidth: "160px" }}
                          onClick={updatePermissions}
                        />
                      )}
                    </div>

                    {/* Permissions List */}
                    {selectedRole?.permissions && selectedRole.permissions.length > 0 ? (
                      <div style={{ maxHeight: "600px", overflowY: "auto", paddingRight: "8px" }}>
                        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                          {selectedRole.permissions.map((item, index) => (
                            <li 
                              key={item.id} 
                              style={{
                                padding: "14px 16px",
                                marginBottom: "8px",
                                background: "#ffffff",
                                borderRadius: "8px",
                                border: "1px solid #e0e0e0",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                transition: "all 0.2s ease"
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.borderColor = "#667eea";
                                e.currentTarget.style.boxShadow = "0 2px 8px rgba(102, 126, 234, 0.1)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.borderColor = "#e0e0e0";
                                e.currentTarget.style.boxShadow = "none";
                              }}
                            >
                              <div style={{ display: "flex", alignItems: "center", gap: "12px", flex: 1 }}>
                                <i 
                                  className="fa fa-check-circle" 
                                  style={{ 
                                    fontSize: "16px", 
                                    color: item.enabled ? "#10b981" : "#d1d5db" 
                                  }}
                                ></i>
                                <span style={{ 
                                  fontSize: "14px", 
                                  fontWeight: "500", 
                                  color: "#333" 
                                }}>
                                  {item.name}
                                </span>
                              </div>
                              <div className="status-toggle">
                                <input
                                  disabled={!selectedRole?.can_update_permissions}
                                  type="checkbox"
                                  id={item.id}
                                  className="check"
                                  checked={item.enabled}
                                  onChange={(e) => changePermission(e, index)}
                                  style={{ cursor: selectedRole?.can_update_permissions ? "pointer" : "not-allowed" }}
                                />
                                <label 
                                  htmlFor={item.id} 
                                  className="checktoggle"
                                  style={{ cursor: selectedRole?.can_update_permissions ? "pointer" : "not-allowed" }}
                                >
                                  checkbox
                                </label>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ) : (
                      <div style={{
                        textAlign: "center",
                        padding: "60px 20px",
                        background: "#f8f9fa",
                        borderRadius: "8px",
                        border: "1px dashed #dee2e6"
                      }}>
                        <i className="fa fa-lock" style={{ fontSize: "32px", color: "#adb5bd", marginBottom: "12px" }}></i>
                        <p style={{ color: "#8b949e", fontSize: "14px", marginBottom: 0 }}>No permissions available</p>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                  <div className="card-body p-4">
                    <div style={{
                      textAlign: "center",
                      padding: "60px 20px"
                    }}>
                      <i className="fa fa-hand-pointer" style={{ fontSize: "48px", color: "#adb5bd", marginBottom: "16px" }}></i>
                      <h5 style={{ fontSize: "18px", fontWeight: "600", color: "#333", marginBottom: "8px" }}>
                        Select a Role
                      </h5>
                      <p style={{ color: "#8b949e", fontSize: "14px", marginBottom: 0 }}>
                        Choose a role from the left sidebar to view and manage its permissions
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <RolesPermissionsModal />
        <DeleteModal Name="Role" />
      </div>
    </>
  );
};

export default RolesPermissions;
